import service from "@/store/services/cash-register-reading-expense-items-service";

export const state = () => ({
  list: {},
  cashRegisterReadingExpenseItem: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, cashRegisterReadingExpenseItem) => {
    state.cashRegisterReadingExpenseItem = cashRegisterReadingExpenseItem;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((cashRegisterReadingExpenseItem) => {
      commit("SET_RESOURCE", cashRegisterReadingExpenseItem);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((cashRegisterReadingExpenseItem) => {
      commit("SET_RESOURCE", cashRegisterReadingExpenseItem);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((cashRegisterReadingExpenseItem) => {
      commit("SET_RESOURCE", cashRegisterReadingExpenseItem);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  cashRegisterReadingExpenseItem: (state) => state.cashRegisterReadingExpenseItem,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((cashRegisterReadingExpenseItem) => ({
      id: cashRegisterReadingExpenseItem.id,
      name: ``,
    }));
  },
};

const cashRegisterReadingExpenseItems = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default cashRegisterReadingExpenseItems;
